<div
  class="ntt-alert ntt-alert--{{ type() }}"
  (mouseenter)="emitEnter()"
  (mouseleave)="emitLeave()"
>
  <div class="ntt-alert__header">
    <ntt-featured-icon
      [color]="iconColor()"
      [icon]="iconName()"
      size="md"
      theme="outline"
    />
    <div class="ntt-alert__message">
      @if (message() !== undefined) {
        {{ message() }}
      } @else {
        <ng-content />
      }
    </div>
    @if (dismissible()) {
      <span
        class="ntt-alert__close icon-x-close"
        tabindex="0"
        (click)="dismiss.emit()"
        (keydown.enter)="dismiss.emit()"
      ></span>
    }
  </div>
  @if (action(); as act) {
    <div class="ntt-alert__action">
      <button type="button" nttLinkButton size="tiny" (click)="runAction(act)">
        {{ act.label }}
      </button>
    </div>
  } @else if (actionsTemplate(); as tpl) {
    <div
      class="ntt-alert__action"
      tabindex="-1"
      (click)="handleActionDismiss()"
    >
      <ng-container [ngTemplateOutlet]="tpl" />
    </div>
  }
</div>
